<template>
  <div>
    <topbar/>
    <div style="padding-left:3%; padding-right:5%; padding-bottom:2%;">
      <div class="row mt-3">
        <div class="col-10">
          <h1>
            <span>{{data.name}}</span>
            <button type="button" class="ml-2 btn btn-success" v-if="currentPhase.phase.name !== 'Canceled' && currentPhase.phase.name !== 'Closed'" @click="nextPhase">Send to next phase</button>
            <button type="button" class="ml-2 btn btn-danger" v-if="currentPhase.phase.name !== 'Canceled' && currentPhase.phase.name !== 'Open'" @click="previousPhase">Send to previous phase</button>
          </h1>
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-danger float-right" v-if="isAdmin && currentPhase.phase.name !== 'Canceled'" @click="cancel">Cancel project</button>
        </div>
      </div>
      <template>
        <form> <!-- tepmorary -->
          <br>
          <h2 class="mt 2">
            Project specification
          </h2>
          <br>
          <div class="row mb-2">
            <div class="col">
              <h5>Created by <span class="mx-1 oi oi-person"> </span>
                <router-link :to="'/user/' + data.owner.id">{{data.owner.username}}</router-link>
              </h5>
            </div>
            <div class="col-1" v-if="currentPhase">
              <h3><span class="badge" :class="'badge-' + $getPhaseColorByName(currentPhase.phase.name)">
                {{ currentPhase.phase.name }}
              </span></h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="progress">
                <div class="progress-bar active" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100"
                     :style="{width: (data.phases[data.phases.length - 1].phase.id * 100 / 11 ) + '%'}">
                </div>
              </div>
            </div>
          </div>
          <h3 v-if="isSpecified" class="mt-3">Edit specification</h3>
          <h3 v-else class="mt-3">Specification</h3>
          <div class="row mt-4">
            <div class="col">
              <div class="col-12 text-secondary">
                <label for="intentNameInput">Intent name</label>
              </div>
              <div class="form-group">
                <div class="input-group mb-2">
                  <input :readonly="isSpecified" :disabled="isSpecified" v-model="data.intent[0].name" type="text" class="form-control" id="intentNameInput"
                          placeholder="Intent name">
                </div>
              </div>

              <div class="col-12 text-secondary">
                <label for="shortSummaryInput">Short intent summary</label>
              </div>
              <div class="form-group">
                <div class="input-group mb-2">
                  <input :readonly="isSpecified" :disabled="isSpecified" v-model="data.intent[0].short_summary" type="text" class="form-control" id="shortSummaryInput"
                          placeholder="Short intent summary" >
                </div>
              </div>

              <div class="col-12 text-secondary">
                <label for="longSummaryInput">Long intent summary</label>
              </div>
              <div class="form-group">
                <div class="input-group mb-2">
                            <textarea :readonly="isSpecified" :disabled="isSpecified" v-model="data.intent[0].long_summary" id="longSummaryInput" class="form-control" rows = "6" cols = "60" name = "description"
                                      placeholder="">Long intent summary</textarea>
                </div>
              </div>
              <!--TODO: parse matrix-->
              <h2 class="mt-5">Logical framework matrix</h2>

              <table class="table table-bordered table-active">
                <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Project summary</th>
                  <th scope="col">Indicators</th>
                  <th scope="col">Means of verifications</th>
                  <th scope="col">Assumptions</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">Goals</th>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'goals', 0)" :value="data.matrix[0].goals.split('|')[0]" id="textareaa11" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'indicators', 0)" :value="data.matrix[0].indicators.split('|')[0]" id="textareaa12" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'sources', 0)" :value="data.matrix[0].sources.split('|')[0]" id="textareaa13" class="form-control" rows="3" cols="10"></textarea></td>
                  <td></td>

                </tr>
                <tr>
                  <th scope="row">Output</th>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'goals', 1)" :value="data.matrix[0].goals.split('|')[1]" id="textareaa21" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'indicators', 1)" :value="data.matrix[0].indicators.split('|')[1]" id="textareaa22" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'sources', 1)" :value="data.matrix[0].sources.split('|')[1]" id="textareaa23" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'assumption', 1)" :value="data.matrix[0].assumption.split('|')[1]" id="textareaa24" class="form-control" rows="3" cols="10"></textarea></td>

                </tr>
                <tr>
                  <th scope="row">Outcome</th>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'goals', 2)" :value="data.matrix[0].goals.split('|')[2]" id="textareaa31" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'indicators', 2)" :value="data.matrix[0].indicators.split('|')[2]" id="textareaa32" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'sources', 2)" :value="data.matrix[0].sources.split('|')[2]" id="textareaa33" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'assumption', 2)" :value="data.matrix[0].assumption.split('|')[2]" id="textareaa34" class="form-control" rows="3" cols="10"></textarea></td>

                </tr>
                <tr>
                  <th scope="row">Activities</th>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'goals', 3)" :value="data.matrix[0].goals.split('|')[3]" id="textareaa41" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'indicators', 3)" :value="data.matrix[0].indicators.split('|')[3]" id="textareaa42" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'sources', 3)" :value="data.matrix[0].sources.split('|')[3]" id="textareaa43" class="form-control" rows="3" cols="10"></textarea></td>
                  <td><textarea :readonly="isSpecified" :disabled="isSpecified" @input="matrixChange($event, 'assumption', 3)" :value="data.matrix[0].assumption.split('|')[3]" id="textareaa44" class="form-control" rows="3" cols="10"></textarea></td>

                </tr>
                </tbody>
              </table>

              <div v-if="!isSpecified" class="row">
                <div class="col-12 col-sm-12 col-md-12">
                  <button type="button" class="btn btn-success float-right" @click="save">Save specifications</button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <div clas="row">
        <div class="row">
          <h4 class="mt-3">Participants</h4>
          <table class="table table-hover">
            <thead class="table-active">
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="person.id" v-for="person in data.participants">
              <td><span class="oi oi-person"></span> {{person.username}}</td>
              <td>{{person.email}}</td>
              <td>{{person.phone_number}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="row" v-if="isOwner">
          <div class="form-group">
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <span class="oi oi-person" title="person" aria-hidden="true"></span>
                </div>
              </div>
              <b-form-select placeholder="Username" @change="addParticipiant" :options="users" value-field="id" text-field="username"></b-form-select>
            </div>
          </div>
          <div class="col-9">
            <button type="button" class="btn btn-success" @click="save">Save participants</button>
          </div>
        </div>
      </div>
      <div class="row">
        <h4 class="mt-3">Verification criteria</h4>
        <table class="table table-hover">
          <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Criterion</th>
            <th scope="col">Passed</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr :key="crit.id" v-for="(crit, index) in data.verification_criterias">
            <th scope="row">{{index + 1}}</th>
            <td>{{crit.name}}</td>
            <td class="text-center"><input :checked="crit.passed === '1'" @change="critTogglePassed($event, crit)" type="checkbox"></td>
            <td class="text-center"><button @click="removeCrit(crit)" class="btn btn-danger">Delete</button></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row" v-if="isOwner">
        <div class="col-12 text-secondary">
          <label for="addCriterion">Criterion</label>
        </div>
        <div class="form-group col-9">
          <input type="text" class="form-control" id="addCriterion"
                 placeholder="New criterion" v-model="newCriteriaName">
        </div>
        <div class="col-3">
          <button type="button" class="btn btn-success float-right" @click="addCriteria">Add criterion to project</button>
        </div>
      </div>
      <!-- another subpage goes there -->
      <div class="row mt-1">
        <div class="col">
          <br>
          <h2 class="mt 2">
            Project phases
          </h2>
          <br>
          <div class="row offset-1" :key="phase.id" v-for="(phase) in phases">
            <div class="col-2">
              <div class="row">
                <div class="col-1">
                  <div class ="circle" :class="{green: savePhase(phase)}"></div>
                </div>
                <div class="col mt-5 ml-3">
                  {{phase.name}}
                </div>
              </div>
            </div>
            <div class="col-1">
              <label for="date-picker-3a" class="text-secondary">Start date</label>
              <input v-model="phaseStartDate[phase.id]" placeholder="" type="text" id="date-picker-3a" class="form-control datepicker ">
            </div>
            <div class="col-1">
              <label for="date-picker-3b" class="text-secondary">End date</label>
              <input v-model="phaseEndDate[phase.id]" placeholder="" type="text" id="date-picker-3b" class="form-control datepicker ">
            </div>
            <div class="col-3 ml-2 pt-2">
              <div class="input-group mt-4">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <span class="oi oi-person" title="person" aria-hidden="true"></span>
                  </div>
                </div>
                <b-form-select class="form-control" placeholder="Username" v-model="phaseResponsibleUser[phase.id]" :options="users" value-field="id" text-field="username"></b-form-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-sm-9 col-md-9">
              <button type="button" class="btn btn-success float-right" @click="savePhases">Save phases</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { projectPhases } from '../store'
import Topbar from '../components/Topbar'
export default {
  name: 'ProjectDetail',
  components: { Topbar },
  watch: {
    'data.phases' (newValue, oldValue) {
      for (let phase of newValue) {
        this.phaseStartDate[parseInt(phase.phase.id)] = phase.start_date
        this.phaseEndDate[parseInt(phase.phase.id)] = phase.end_date
        this.phaseResponsibleUser[parseInt(phase.phase.id)] = phase.responsible_user[0].id
      }
    }
  },
  computed: {
    data: {
      get () {
        return this.$store.getters.project
      },
      set (data) {
        console.log(data)
      }
    },
    isAdmin () {
      return this.$store.getters.isAdmin
    },
    currentPhase () {
      if (this.data) {
        if (this.data.phases.length > 0) {
          return this.data.phases[this.data.phases.length - 1]
        }
      }
      return null
    },
    user () {
      return this.$store.getters.user
    },
    users () {
      return this.$store.getters.users
    },
    isSpecified () {
      return this.currentPhase.phase.name !== 'Open'
    },
    isOwner () {
      if (this.data) {
        return parseInt(this.data.owner.id) === parseInt(this.user.id)
      }
      return false
    }
  },
  mounted () {
    this.loadProject()
  },
  methods: {
    loadProject () {
      this.$store.dispatch('loadProject', this.$route.params.id)
    },
    nextPhase () {
      if (this.currentPhase.phase.name !== 'Canceled') {
        let phase = this.phases[parseInt(this.currentPhase.phase.id)]
        phase.id = phase.id.toString()
        this.data.phases[this.data.phases.length - 1].end_date = new Date().toISOString().slice(0, 10)
        this.data.phases.push({
          start_date: new Date().toISOString().slice(0, 10),
          end_date: null,
          responsible_user: [this.user],
          phase: phase
        })
        this.save()
      }
    },
    previousPhase () {
      if (this.currentPhase.phase.name !== 'Open') {
        this.data.phases.pop()
        this.save()
      }
    },
    cancel () {
      this.data.phases.push({
        start_date: Date.now(),
        end_date: null,
        responsible_user: this.user,
        phase: this.phases[10]
      })
      this.save()
    },
    matrixChange (text, what, index) {
      let tmp = this.data.matrix[0][what].split('|')
      tmp[index] = text.target.value
      this.data.matrix[0][what] = tmp.join('|')
    },
    critTogglePassed (e, crit) {
      let val = e.target.checked
      let critIdx = this.data.verification_criterias.findIndex(c => c.id === crit.id)
      this.data.verification_criterias[critIdx].passed = val ? '1' : '0'
      this.save()
    },
    removeCrit (crit) {
      let critIdx = this.data.verification_criterias.findIndex(c => c.id === crit.id)
      this.data.verification_criterias.splice(critIdx, 1)
      this.save()
    },
    addParticipiant (id) {
      this.data.participants.push(this.users.find(u => u.id === id))
    },
    addCriteria () {
      this.data.verification_criterias.push({
        name: this.newCriteriaName,
        passed: false
      })
      this.newCriteriaName = ''
      this.save()
    },
    savePhases () {
      for (let phase of this.phases) {
        if (this.phaseStartDate[phase.id] || this.phaseEndDate[phase.id] || this.phaseResponsibleUser[phase.id]) {
          let idx = this.data.phases.findIndex(p => parseInt(p.phase.id) === parseInt(phase.id))
          if (idx === -1) {
            this.data.phases.push({
              start_date: this.phaseStartDate[phase.id],
              end_date: this.phaseEndDate[phase.id],
              responsible_user: [this.users.find(u => u.id === this.phaseResponsibleUser[phase.id])],
              phase: phase
            })
          } else {
            this.data.phases[idx] = {
              start_date: this.phaseStartDate[phase.id],
              end_date: this.phaseEndDate[phase.id],
              responsible_user: [this.users.find(u => u.id === this.phaseResponsibleUser[phase.id])],
              phase: phase
            }
          }
        }
      }
      this.save()
    },
    savePhase (phase) {
      for (let p of this.data.phases) {
        if (parseInt(p.phase.id) === parseInt(phase.id)) {
          return true
        }
      }
      return false
    },
    save () {
      let payload = JSON.parse(JSON.stringify(this.data))
      payload.portfolio_manager = payload.portfolio_manager ? payload.portfolio_manager[0] : null
      payload.resolution = payload.resolution ? payload.resolution[0] : null
      payload.intent = payload.intent ? payload.intent[0] : null
      payload.matrix = payload.matrix ? payload.matrix[0] : null
      for (let phase of payload.phases) {
        if (phase.responsible_user.length > 0) {
          phase.responsible_user = phase.responsible_user[0]
        }
      }
      this.axios.put(this.$serverAddr + '/project/' + this.data.id, payload).then((response) => {
        this.$bvToast.toast(response.data, {
          title: 'Success',
          autoHideDelay: 5000,
          variant: 'success'
        })
      })
    }
  },
  data () {
    return {
      newParticipiantName: '',
      newCriteriaName: '',
      phases: projectPhases,
      phaseStartDate: [],
      phaseEndDate: [],
      phaseResponsibleUser: []
    }
  }
}
</script>

<style scoped>

</style>
